import { setup } from "@loomhq/record-sdk";
import { isSupported } from "@loomhq/record-sdk/is-supported";
import moment from "moment";
import { useEffect } from "react";
import submit from "submit-form";
import { DATE_FORMATS, LOOM_API_KEY } from "../constants";

const { DATE_DAY_FORMAT } = DATE_FORMATS;

export default function RecordButtonHeader({ locals, BUTTON_ID }) {
  const { query } = locals;

  useEffect(() => {
    async function setupLoom() {
      const { supported } = await isSupported();

      const button = document.getElementById(BUTTON_ID);

      if (!supported) {
        button.addEventListener("click", (e) => {
          alert(
            "Incompatible browser\n\nThe browsers compatible with the loom video feature are:\n\n - Chrome\n - Brave\n - Edge"
          );
        });
        return;
      }

      if (!button) {
        return;
      }

      const { configureButton } = await setup({
        publicAppId: LOOM_API_KEY,
      });

      const sdkButton = configureButton({ element: button });

      sdkButton.on("insert-click", async (shareLink) => {
        const date = moment().format(DATE_DAY_FORMAT);

        console.log({ shareLink });

        submit("/actions/exercise/edit-video-record", {
          method: "POST",
          body: {
            date,
            shareLink,
            athleteId: query.athlete,
            _id: null,
            type: "general",
          },
        });
      });
    }

    setupLoom();
  }, [query]);

  return (
    <button id={BUTTON_ID} data-button-type="secondary">
      <img src="/img/icons/loom-record.svg" className="h-4 w-4 mr-2" />
      <span>Record Video</span>
    </button>
  );
}
